<template>
  <div class="BasicEduParents">
    <div class="BasicEduParents-part4">
         <h1>家长购买</h1>
      <div class="container">
        <p class="part4-con">
          Apple 一直致力为校方提供顶尖的科技工具和服务，<br>多年来，世界各地的学校运用Mac和iPad开展各项教学活动，<br>显著提升了学生的学习积极性、创造力和综合能力。
        </p>
        <img class="edu-image" src="../assets/img/cs-jiazhang_buy.jpg" alt="">
        <p class="part4-con">
          为了帮助您的学校更好达成科技助力学习的目标，<br>我们为贵校提供专属的学生、家长购买苹果教育产品的支持方案，<br>同时我们也为家长推荐充分满足教学和学习的Mac和iPad型号，<br>且产品享受专属教育特惠价格。
        </p>
        <div class="service-box">
          <img src="../assets/img/20250729/service.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="BasicEduParents-part5">
      <div class="container">
        <h2>专属教育优惠</h2>
        <h2>EDU Price</h2>
        <h2>一校一店，不仅仅是优惠价格</h2>
        <h2>详见选购流程：</h2>
        <el-row class="qrcode-box" :gutter="20">
          <el-col :xs="12" :sm="6">
            <div>
              <img class="logo-img" src="../assets/img/20250729/qrcode/xlis_logo.jpg" alt="">
              <img class="qrcode-img" src="../assets/img/20250729/qrcode/xlis_qrcode.png" alt="">
              <div>
                <p>西安梁家滩国际学校优惠网站：</p>
                <p>Scan QR code or Click the URL:</p>
                <p class="url-link" @click="openUrl(websiteUrl['xlis'])">{{websiteUrl['xlis']}}</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="6">
            <div>
              <img class="logo-img" src="../assets/img/20250729/qrcode/bcis_logo.jpg" alt="">
              <img class="qrcode-img" src="../assets/img/20250729/qrcode/bcis_qrcode.png" alt="">
              <div>
                <p>北京市朝阳区乐成学校优惠网站:</p>
                <p>Scan QR code or Click the URL:</p>
                <p class="url-link" @click="openUrl(websiteUrl['bcis'])">{{websiteUrl['bcis']}}</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="6">
            <div>
              <img class="logo-img" src="../assets/img/20250729/qrcode/ka_logo.jpg" alt="">
              <img class="qrcode-img" src="../assets/img/20250729/qrcode/ka_qrcode.png" alt="">
              <div>
                <p>凯文教育集团优惠网站：</p>
                <p>Scan QR code or Click the URL:</p>
                <p class="url-link" @click="openUrl(websiteUrl['ka'])">{{websiteUrl['ka']}}</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="6">
            <div>
              <img class="logo-img" src="../assets/img/20250729/qrcode/gzhm_logo.png" alt="">
              <img class="qrcode-img" src="../assets/img/20250729/qrcode/gzhm_qrcode.png" alt="">
              <div>
                <p>华美英语实验学校优惠网站：</p>
                <p>Scan QR code or Click the URL:</p>
                <p class="url-link" @click="openUrl(websiteUrl['gzhm'])">{{websiteUrl['gzhm']}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="BasicEduParents-part1">
      <div class="container">
        <!-- <h1>家长</h1> -->
        <p class="p1">AppleCare 为你提供</p>
        <p class="p2">
          长期的技术支持与服务。<br />获得更多服务和支持。为你的 Mac 选购
          AppleCare+ 服务计划，享受教育优惠价格。
        </p>
        <img src="../assets/img/icon-basePar-1.png" alt="" />
      </div>
    </div>
    <div class="BasicEduParents-part2">
      <div class="container">
        <h1>让旧设备物尽其用</h1>
        <p>
          你可以用符合条件的设备来换购，并在购买新设备时享受折抵优惠。如果你的设备不符合折抵条件，我们会免费将其回收处理。不论设备型号或状况如何，我们都可以物尽其用，让你和地球都从中受益。
        </p>
        <div class="cs-page">
          <router-link to="DaaSLeasingAgent" active-class="activeClass">以旧换新</router-link>
        </div>
        <img src="../assets/img/icon-basePar-2.png" alt="" />
      </div>
    </div>
    <div class="BasicEduParents-part3">
      <img src="../assets/img/cs-basePar-1.jpg" alt="" />
      <div class="con">
        <div class="conbox">
          <h1>iOS 数字校园</h1>
          <p class="p1">
            高校学生、老师以及为高校学生购买设备的家长，享受教育专属优惠。
          </p>
          <div class="button">
            <a href="http://mall.jschuangsen.cn/Home/User/login">
              开始选购 <span class="el-icon-arrow-right"></span>
            </a>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>

    <div class="cs-page">
      <router-link to="home" active-class="activeClass">首页</router-link>
      <router-link to="BasicEduTeacherResource" active-class="activeClass">上一页</router-link>
      <router-link to="BasicEduIT" active-class="activeClass">下一页</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "BasicEduParents",
  data() {
    return {
      websiteUrl: {
        'xlis': 'http://k12.mac4me.com/index.php/goods/goods_all?url_code=11uvnhjow8',
        'bcis': 'http://k12.mac4me.com/index.php/goods/goods_all?url_code=cc0f68c981',
        'ka': 'http://k12.mac4me.com/index.php/goods/goods all?url_code=0f09717a03',
        'gzhm': 'http://k12.mac4me.com/index.php/goods/goods_all?url_code=7bfbf3c8b0',
      }
    };
  },
  mounted() {},
  methods: {
    openUrl(url) {
      window.open(url, '_blank')
    },
  },
};
</script>
<style lang="scss">
.BasicEduParents {
  border-bottom: 1px solid #d6d6d6;
  .BasicEduParents-part1 {
    text-align: center;
    padding-bottom: 110px;
    img {
      max-width: 100%;
    }
    h1 {
      font-size: 58px;
      font-weight: 600;
      color: #000000;
      line-height: 76px;
      padding: 115px 0 73px 0;
    }
    .p1 {
      font-size: 42px;
      font-weight: 600;
      color: #000000;
      line-height: 38px;
      padding-top: 73px;
    }
    .p2 {
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
      margin: 37px 0 77px 0;
    }
  }

  .BasicEduParents-part2 {
    background: #fff;
    text-align: center;
    padding: 112px 0 113px 0;
    img {
      max-width: 100%;
    }
    h1 {
      font-size: 42px;
      font-weight: 600;
      color: #000000;
      line-height: 38px;
    }
    p {
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
      margin: 41px 0 0;
    }
    .cs-page{
      padding-top: 20px;
    }
  }

  .BasicEduParents-part3 {
    text-align: center;
    position: relative;
    img {
      max-width: 100%;
    }
    .con {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1200px;
      margin-left: -600px;
      margin-top: -120px;

      .conbox {
        width: 1200px;
        //  height: 768px;
        height: 100%;
        margin: 0 auto;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
      }
      h1 {
        font-size: 42px;
        font-weight: 600;
        color: #ffffff;
        line-height: 38px;
      }
      .p1 {
        width: 849px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 38px;
        text-align: center;
        margin: 40px auto 44px auto;
      }
      .button {
        width: 240px;
        height: 76px;
        background: #0071e3;
        border-radius: 38px;
        display: inline-block;
        a {
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 76px;
          font-size: 28px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .BasicEduParents-part4{
    padding: 60px 0 60px;
    .part4-con{
      margin-bottom: 20px;
      padding: 0 20px;
      font-size: 24px;
      text-align: center;
    }
    .edu-image{
     display: block;
     max-width: 860px;
     width: 100%;
     height: auto;
     margin: 40px auto 40px auto;
     border-radius: 22px;
    }
    .service-box{
      text-align: center;
      img{
        width: 95%;
      }
    }
     h1 {
        font-size: 42px;
        font-weight: 600;
        text-align: center;
        line-height: 38px;
        padding-bottom:20px;
      }
  }

  .BasicEduParents-part5{
    background-color: #fff;
    padding: 80px 0;
    h2{
      margin-bottom: 20px;
      font-size: 40px;
      text-align: center;
    }
    .qrcode-box{
      margin-top: 40px;
      .el-col{
        margin: 10px 0;
        & > div{
          // margin: 0 15px;
          padding: 30px 10px 15px;
          border: 1px solid #ccc;
          border-radius: 22px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          .logo-img{
            height: 50px;
          }
          .qrcode-img{
            margin: 20px 0;
            height: 120px;
          }
          p{
            font-size: 14px;
            text-align: center;
            &.url-link{
              cursor: pointer;
              &:hover{
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}
// 适配
@media screen and (max-width: 768px) {
  .BasicEduParents {
    .BasicEduParents-part3 {
      height: 320px;
      img {
        max-height: 100%;
        max-width: none !important;
      }
    }
  }
}
</style>
